/** Joins class names and drops the falsy ones: `cx(styles.root, open && styles.isOpen)`. */
export const cx = (...parts: readonly (string | false | null | undefined)[]): string =>
  parts.filter(Boolean).join(' ')
